var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isVisible),expression:"isVisible"}],key:_vm.uuid,ref:_vm.uuid,staticClass:"json__comma",attrs:{"data-uuid":_vm.uuid}},[_vm._v(",")])}
var staticRenderFns = []

export { render, staticRenderFns }